import React from 'react';
import Flagship from '../../core/flagship';
import SingleRecordField from './SingleRecordField';

import {empty,renderFieldValue} from '../../utils/helpers';
import {Table, Loader, Label} from 'semantic-ui-react';

const SingleRecordView = (props) => {

    if( typeof props.recordData === "undefined" ) {
        return (
            <Table>
                <Table.Body>
                    <Table.Row>
                        <Table.Cell colSpan="5">
                            <Loader className="flagship-loader" active inline='centered' >
                                Loading...
                            </Loader>
                        </Table.Cell>
                    </Table.Row>
                </Table.Body>
            </Table>
        );
    } else {
        let readOnly = props.readOnly;

        if ( !empty( props.recordData.record ) ) {
            return (
                <div>

                    {!empty(Flagship.config.records[props.recordData.record.record_type].extra1) && !empty(props.recordData.record.extra1) ?
                        <div key="record-extra1" className="single-record-single-field">
                            <Label>{Flagship.config.records[props.recordData.record.record_type].extra1.label}</Label>
                            <div className="field-value">
                                {renderFieldValue(props.recordData.record.extra1, Flagship.config.records[props.recordData.record.record_type].extra1.validation)}
                            </div>
                        </div>
                        : null}

                    {!empty(Flagship.config.records[props.recordData.record.record_type].extra2) && !empty(props.recordData.record.extra2) ?
                        <div key="record-extra2" className="single-record-single-field">
                            <Label>{Flagship.config.records[props.recordData.record.record_type].extra2.label}</Label>
                            <div className="field-value">
                                {renderFieldValue(props.recordData.record.extra2, Flagship.config.records[props.recordData.record.record_type].extra2.validation)}
                            </div>
                        </div>
                        : null}

                    {!empty(Flagship.config.records[props.recordData.record.record_type].extra3) && !empty(props.recordData.record.extra3) ?
                        <div key="record-extra3" className="single-record-single-field">
                            <Label>{Flagship.config.records[props.recordData.record.record_type].extra3.label}</Label>
                            <div className="field-value">
                                {renderFieldValue(props.recordData.record.extra3, Flagship.config.records[props.recordData.record.record_type].extra3.validation)}
                            </div>
                        </div>
                        : null}


                    {props.recordData.data.map(function (item, i) {
                        return (
                            <SingleRecordField
                                recordId={props.recordData.record.id}
                                afterSave={props.getRecordData}
                                readOnly={readOnly}
                                key={'field-' + i}
                                {...item} />
                        );
                    })}


                </div>
            );
        } else {
            return (
              <div>Nothing found.</div>
            );
        }

    }
};

export default SingleRecordView;


// WEBPACK FOOTER //
// ./src/components/records/SingleRecordView.js